<div style="height: 100%; width: 100%;">
<optima-explorer
#kpiExplorer
[isLoading]="isLoading()"
[explorerAttributes]="explorerAttributes"
[contentTotalCount]="getPaginationTotalCount(explorerContentAttributes.currentSelectedItem || '', explorerContentAttributes.data.length)"
[contentItemCountPerPage]="contentItemCountPerPage"
[dataRefreshedToken]="dataRefreshedToken"
(paginationRequest)="onPaginationRequest($event)"
(subHeaderOnClickAddButtonOptionEmitter)="onAddButtonOptionClick($event)"
(subHeaderOnForwardButtonClickedEmitter)="itemClicked($event,false)"
(explorerNavonExplorerNavOnItemRightClickEmitter)="processContentContextMenuClicked($event)"
(explorerNavOnNavItemClickedEmitter)="navItemClicked($event)"
(explorerContentOncontextMenuClickEmitter)="processContentContextMenuClicked($event)"></optima-explorer>
</div>
<!-- <app-off-canvas-collective></app-off-canvas-collective> -->
